export const menuItems=[
    {
        name:"Home",
        url:"/",
        cname:"item",
        icon:"fa-solid fa-house-user"
    },
    {
        name:"About",
        url:"/about",
        cname:"item",
        icon:"fa-solid fa-circle-info "
    },
    {
        name:"Contact",
        url:"/contact",
        cname:"item",
        icon:"fa-solid fa-address-book"
    },
    {
        name:"Service",
        url:"/service",
        cname:"item",
        icon:"fa-solid fa-briefcase"
    },
    {
        name:"Sign Up",
        url:"/signup",
        cname:"signup"
        }
]